const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchCertificates = async (token) => {
    const url = `${BASE_URL}/accounts/sign/identities?idpid=tx`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch certificates');
    }

    return await response.json();
};

export const fetchCertificateDetails = async (token, identityId) => {
    const url = `${BASE_URL}/accounts/sign/identity?idpid=tx&identity_id=${identityId}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch certificate details');
    }

    return await response.json();
};
export const validatePin = async (token, signIdentityId, certificateId, pin) => {
    const url = `${BASE_URL}/accounts/users/validate_pin?idpid=tx&user=${signIdentityId}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            sign_identity_id: certificateId,
            value: pin
        })
    });

    if (!response.ok) {
        throw new Error('Failed to validate PIN');
    }

    return await response.json();
};


export const getUserInfo = async (token) => {
    const url = `${BASE_URL}/accounts/users/userinfo?idpid=tx`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch user info');
    }

    return await response.json();
};
